import review1 from './../images/review/review1.png'
import vnk_Ieva from './../images/review/vnk_Ieva.jpg'
import inga_okorkova from './../images/review/inga_okorkova.jpg'
import nadejda_semenova from './../images/review/nadejda_semenova.jpg'
import jelena_lensa from './../images/review/jelena_lensa.jpg'
import egija_va from './../images/review/egija_va.jpg'

export const reviews = [
    {
        name: "Egija VA",
        date: "20.02.2026",
        description: `Vēlos izteikt lielu pateicību tūrisma aģentūrai par izcili organizētiem mūsu ceļojumiem. No pirmā kontakta brīža jūtama profesionāla un patiesa ieinteresētība atrast man vispiemērotākos piedāvājumus. Vienmēr palīdz ar visiem organizatoriskajiem jautājumiem un bija sasniedzama jebkurā brīdī, ja radās kādi papildus jautājumi.
Īpaši novērtēju individuālo pieeju un rūpes par klientu.
Noteikti iesaku šo tūrisma aģentūru ikvienam, kas vēlas kvalitatīvu, drošu un patīkamu ceļojuma pieredzi.
Noteikti izmantošu vēl šīs aģentūras pakalpojumus!`,
        image: egija_va
    },
    {
        name: "Jeļena Lenša",
        date: "20.12.2025",
        description: `Tatjana Lāce ir lieliska ceļojumu aģente! 🌍
Viņa patiesi ieklausās klienta vēlmēs, iedziļinās detaļās un sameklē tieši to, kas vislabāk atbilst vajadzībām un iespējām. Tatjana strādā ar lielu atbildību, rūpību un sirsnību - visu izskaidro saprotami, vienmēr ir sasniedzama un gatava palīdzēt.
Ar Mandarina Travel ceļojuma plānošana kļūst par patīkamu un drošu procesu. No sirds iesaku Tatjanu ikvienam, kas vēlas kvalitatīvu un personisku pieeju! 🫶✈️`,
        image: jelena_lensa
    },
    {
        name: "Надежда Семёнова",
        date: "19.12.2025",
        description: `Sirsnīgs paldies tūroperatorei Tatjanai par lieliski noorganizēto ceļojumu uz Turciju! Visa brauciena laikā viņa vienmēr bija ar mums kontaktā - atbildēja gan dienā, gan naktī. Tatjana ļoti palīdzēja visās situācijās, vienmēr bija atsaucīga un rūpīga. Pateicoties viņai, jutāmies droši un mierīgi visa ceļojuma laikā. Noteikti iesakām Tatjanu kā uzticamu un lielisku tūroperatori!`,
        image: nadejda_semenova
    },
    {
        name: "Инга Окоркова",
        date: "07.07.2024",
        description: `No visas mūsu lielās kompānijas sirsnīgs paldies par ceļojumu!
Īpaši pateicamies aģentei Maijai par tik personīgo un jauko attieksmi! Maija ne tikai piedavāja vairākus izdevīgus variantus, bet arī vienmēr bija saziņā ar mums, ka arī dalijās ar noderīgu informāciju un padomiem!
Noteikti iesakām!`,
        image: inga_okorkova
    },
    {
        name: "Vnk Ieva",
        date: "04.03.2024",
        description: `Pasaulīgais Mega Paldies kompānijai par saules stariem Tenerifē februāra izskaņā!Īpašu paldies sakam aģentei Maijai Opmanei😇🙏,kura ne tikai samenedžēja visu turpceļu un atpakaļceļu,bet bija kopā ar mums caur "sakariem" visu ceļojuma laiku,ja radās kādi jautājumi un neskaidrības!Paldies..."Miza" lobās,bet visi laimīgi😁👌💝...un plānojam jau nākošo tripiņu 🏖💃`,
        image: vnk_Ieva
    },
    {
        name: "Iveta Ručkanova",
        date: "27.08.2023",
        description: `Lieliski organizēts ceļojums šovasar uz Krētu, Rethimno, Bali beach. ☆☆☆☆☆ @Maija Opmane no ceļojumu aģentūras "Mandarina" vienkārši kolosāli visu ieteica un spēja piemeklēt ideālu variantu atbilstoši manām prasībām. Un, lai arī manam  budžetam nebija stingru robežu, tika piemeklēts visatbilstošākais variants, kura rezultātā esmu ļoti, ļoti apmierināta, jo netika iztērēts lieki, kā arī dumji taupīts. 
        Viennozīmīgi iesaku Maiju Opmani!!! Viņa mani gan "sapakoja" ceļojumam, gan "pavadīja ceļā", gan arī ļoti atbildīgi piegāja tam, kā man patīk un kā es jūtos izvēlētajā viesnīcā.
        Jau plānoju nākamo ceļojumu!!! PALDIES! ♡`,
        image: review1
    },
    {
        name: "Aelita Repša",
        date: "31.07.2023",
        description: `Paldies Mandarina trevel par sagatavoto piedāvājumu ceļojumam, kas bij pielāgots mūsu ğimenes vēlmēm! Īpašs paldies ağentei Maijai, par laipnību, pacietību un pretìmnākšanu. Tika sniegti detalizēti argumenti par katru piedāvāto viesnīcu, vēlamajā izmaksu kategorijā, perfekta speciāliste savā jomā!!! Turcijā tika pavadītas fantastiska nedēļa, foršā viesnīcā...Paldies!`,
        image: ''
    },


]
